const ZOOM_ALLOWED_SELECTOR = '[data-allow-browser-zoom="true"]';

const ZOOM_SHORTCUT_KEYS = new Set(["+", "-", "=", "_", "0"]);
const ZOOM_SHORTCUT_CODES = new Set(["Equal", "Minus", "Digit0", "NumpadAdd", "NumpadSubtract", "Numpad0"]);

function isZoomAllowed(target: EventTarget | null) {
  return target instanceof Element && Boolean(target.closest(ZOOM_ALLOWED_SELECTOR));
}

function preventBrowserDefault(event: Event) {
  if (isZoomAllowed(event.target) || !event.cancelable) return;
  event.preventDefault();
}

export function lockBrowserZoom() {
  const activeOptions = { passive: false } as AddEventListenerOptions;

  const preventGestureZoom = (event: Event) => {
    preventBrowserDefault(event);
  };

  const preventMultiTouchZoom = (event: TouchEvent) => {
    if (event.touches.length > 1) {
      preventBrowserDefault(event);
    }
  };

  const preventWheelZoom = (event: WheelEvent) => {
    if (event.ctrlKey || event.metaKey) {
      preventBrowserDefault(event);
    }
  };

  const preventKeyboardZoom = (event: KeyboardEvent) => {
    if (
      (event.ctrlKey || event.metaKey) &&
      !event.altKey &&
      (ZOOM_SHORTCUT_KEYS.has(event.key) || ZOOM_SHORTCUT_CODES.has(event.code))
    ) {
      preventBrowserDefault(event);
    }
  };

  window.addEventListener("gesturestart", preventGestureZoom, activeOptions);
  window.addEventListener("gesturechange", preventGestureZoom, activeOptions);
  window.addEventListener("gestureend", preventGestureZoom, activeOptions);
  document.addEventListener("touchmove", preventMultiTouchZoom, activeOptions);
  document.addEventListener("wheel", preventWheelZoom, activeOptions);
  document.addEventListener("keydown", preventKeyboardZoom, activeOptions);
}
